import {
    VIEWER_INFO,
    VIEWER_ERROR,
    VIEWER_FETCHING,
} from '../constants/actions';

import {
    fetchViewer,
} from 'ntnu-react/util/sp';

let _viewer;

export function getViewer() {
    return (dispatch) => {
        dispatch({ type: VIEWER_FETCHING });
        if(__DEV__) {
            return dispatch({
                type: VIEWER_INFO,
                payload: require('../mock/viewer.json'),
            });
        }

        // only fetch once - for now
        if (_viewer) {
            return dispatch({
                type: VIEWER_INFO,
                payload: _viewer,
            });
        }

        fetchViewer().then((viewer) => {
            viewer.canAdd = viewer.member || false;
            viewer.canProcess = viewer.admin || false;
            _viewer = viewer;
            dispatch({
                type: VIEWER_INFO,
                payload: viewer,
            });
        }).catch((sender, args) => {
            dispatch({
                type: VIEWER_ERROR,
                payload: args && args.get_message() || '',
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/viewerActions.js